import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from './../../actions'
import SelectFreeWord from './../../components/site/select_free_word'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  selectFreeWord: state.searchFormCondition.selectFreeWord,
})

const SelectFreeWordContainer = connect(mapStateToProps, mapDispatchToProps)(SelectFreeWord)

export default SelectFreeWordContainer
